import type { BuildingSocietySavingsSettingsDetailsCountryConfig } from '../../BuildingSocietySavingsSettingsDetailsConfig';

export const savingsSettingsDetails: BuildingSocietySavingsSettingsDetailsCountryConfig = {
    displayIban: true,
    displayBic: true,
};
